export let LogoutApp = async () => {
 // dispatch(Actions.updateBlockedAppStatus({
 //    blocked: false,
 //    message: ""
 // }));
 localStorage.removeItem("profile")
 localStorage.removeItem("token")
 window.location.reload();
}